export default __webpack_public_path__ + "static/media/pinmap.a4720c8f.svg";